<template>
  <div class="search-form px-2">
    <div class="col-sm-12 search-form-title">
      <font-awesome-icon icon="search" />
      {{ $t('common.search') }}
    </div>
    <form
      @submit.prevent="onSubmit"
      @reset="onReset"
    >
        <div class="row">
            <div class="col-sm-4">
                <span class="span-title">{{ $t('general_guides.document_title') }}</span>
                <input
                    id="name"
                    v-model="name"
                    type="text"
                    class="form-control form-control-sm"
                    :placeholder="$t('general_guides.document_title')"
                />
            </div>
            <div class="col-sm-4">
                <span class="span-title">{{ $t('common.description') }}</span>
                <input
                    id="description"
                    v-model="description"
                    type="text"
                    class="form-control form-control-sm"
                    :placeholder="$t('common.description')"
                />
            </div>
            <div class="col-sm-4">
                <span class="span-title">{{ $t('general_guides.added_by') }}</span>
                <input
                    id="added_by"
                    v-model="added_by"
                    type="text"
                    class="form-control form-control-sm"
                    :placeholder="$t('general_guides.added_by')"
                />
            </div>
            <div class="col-sm-4">
                <span class="span-title">{{ $t('general_guides.added_by_company') }}</span>
                <input
                    id="company"
                    v-model="companyName"
                    type="text"
                    class="form-control form-control-sm"
                    :placeholder="$t('general_guides.added_by_company')"
                />
            </div>
            <div class="col-sm-4">
                <span class="span-title">{{ $t('common.from') }}</span>
                <input
                    id="start"
                    v-model="fromDate"
                    type="date"
                    class="form-control form-control-sm"
                />
            </div>
            <div class="col-sm-4">
                <span class="span-title">{{ $t('common.to') }}</span>
                <input
                    id="end"
                    v-model="toDate"
                    type="date"
                    class="form-control form-control-sm"
                />
            </div>
        </div>

        <div class="row">
            <div class="col-sm-4">
                <span class="span-title">{{ $t('general_guides.search_mode') }}</span>
                <div class="form-check" v-for="option in modeOptions" :key="option.value">
                    <input
                        class="form-check-input"
                        type="radio"
                        :id="`searchMode-${option.value}`"
                        :value="option.value"
                        v-model="searchMode"
                        name="radio-options"
                    />
                    <label class="form-check-label" :for="`searchMode-${option.value}`">
                        {{ option.text }}
                    </label>
                </div>
            </div>
        </div>

      <div class="col-sm-12 d-flex justify-content-end">
          <button
            id="reset"
            type="reset"
            class="btn btn-danger form-button"
          >
            {{ $t('ins_report.clear') }}
          </button>
          <button
              id="submit"
              type="submit"
              class="btn btn-primary form-button"
          >
              {{ $t('ins_report.search') }}
          </button>
      </div>
    </form>
  </div>
</template>

<script>
import {timeUtils} from "@/components/mixins/TimeUtils";

export default {
    name: "GeneralGuidesSearch",
    mixins: [timeUtils],
    data: function () {
        return {
            name: '',
            description: '',
            added_time: null,
            added_by: '',
            fromDate: null,
            toDate: null,
            companyName: '',
            searchMode: 1,
            modeOptions: [
                { text: this.$t('general_guides.shared_to'), value: 1 },
                { text: this.$t('general_guides.shared_by'), value: 2 },
            ]
        }
    },

    methods: {
        onSubmit: function () {
            let params = {searchMode: this.searchMode}
            if (this.name) {
                params.name = this.name
            }
            if (this.description) {
                params.description = this.description
            }
            if (this.added_by) {
                params.added_by = this.added_by
            }
            if (this.companyName) {
                params.companyName = this.companyName
            }
            if (this.fromDate !== null && this.fromDate.trim()) {
                params.from = this.getStartOfTheDay(this.fromDate)
            }
            if (this.toDate !== null && this.toDate.trim()) {
                params.to = this.getEndOfTheDay(this.toDate)
            }
            this.$emit('search', params)
        },

        onReset: function () {
            this.name = ''
            this.description = ''
            this.added_by = ''
            this.fromDate = null
            this.toDate = null
        }
    }
}
</script>

